import BrandLogo from '../components/BrandLogo';
import { useState } from 'react';
import TrialSignupConfirmation from '../components/TrialSignupConfirmation';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import RegisterForm from '../components/RegisterForm';
import SEOHead from '../components/SEOHead';

export default function RegisterPage() {
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const [trialResult, setTrialResult] = useState(null);

  const handleRegistrationSuccess = (result) => {
    if (result.requiresTrialLogin) { setTrialResult(result); return; }
    
    // Guardar token si existe
    if (result?.token) {
      localStorage.setItem('auth_token', result.token);
    }
    
    // Mostrar mensaje y redirigir a planes
    setTimeout(() => {
      navigate('/pricing', { 
        state: { 
          fromRegistration: true,
          message: '¡Cuenta creada! Ahora selecciona tu plan para comenzar.' 
        }
      });
    }, 500);
  };

  return (
    <>
      <SEOHead 
        title="Registro - Numerathum"
        description="Crea tu cuenta en Numerathum"
        noindex={true}
      />
      <div className="min-h-screen bg-morado/5 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Header */}
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-8"
        >
          <Link to="/" className="inline-block mb-4">
            <BrandLogo className="w-64" />
          </Link>
          <h1 className="text-3xl font-bold text-morado mb-2">Crear Cuenta</h1>
          <p className="text-gray-600">Comienza tu viaje numerológico</p>
        </motion.div>

        {/* Register Form */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
        >
          {trialResult ? <TrialSignupConfirmation result={trialResult} /> : <RegisterForm initialCode={search.get('code') || ''} onSuccess={handleRegistrationSuccess} />}
        </motion.div>

        {/* Login Link */}
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600">
            ¿Ya tienes cuenta?{' '}
            <Link 
              to="/login" 
              className="text-morado hover:text-morado font-semibold"
            >
              Inicia sesión
            </Link>
          </p>
        </div>
      </div>
    </div>
    </>
  );
}

